import * as React from 'react';

export function SvgAirtable(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9264 4.21102L3.47343 7.29497C3.05897 7.4665 3.06326 8.0552 3.48032 8.22051L10.9645 11.1884C11.6221 11.4492 12.3544 11.4492 13.012 11.1884L20.4963 8.22051C20.9132 8.0552 20.9176 7.4665 20.503 7.29497L13.0502 4.21102C12.3702 3.92966 11.6063 3.92966 10.9264 4.21102"
        fill="#FFBF00"
      />
      <path
        d="M12.6522 12.8091V20.2234C12.6522 20.576 13.0078 20.8175 13.3356 20.6876L21.6753 17.4505C21.8657 17.375 21.9905 17.1911 21.9905 16.9863V9.57208C21.9905 9.21943 21.6349 8.97796 21.3071 9.1079L12.9675 12.345C12.7772 12.4204 12.6522 12.6044 12.6522 12.8091"
        fill="#26B5F8"
      />
      <path
        d="M10.7049 13.1917L8.22983 14.3867L7.97853 14.5082L2.7539 17.0116C2.42271 17.1714 2 16.93 2 16.5621V9.60322C2 9.47011 2.06825 9.3552 2.15977 9.26865C2.19797 9.23034 2.24124 9.19882 2.28621 9.17384C2.41107 9.09893 2.58915 9.07893 2.74056 9.13882L10.6633 12.2779C11.066 12.4377 11.0976 13.002 10.7049 13.1917"
        fill="#ED3049"
      />
      <path
        d="M10.7049 13.1917L8.22985 14.3867L2.15979 9.26865C2.19798 9.23034 2.24126 9.19882 2.28623 9.17384C2.41109 9.09893 2.58917 9.07893 2.74058 9.13882L10.6633 12.2779C11.066 12.4377 11.0976 13.002 10.7049 13.1917"
        fill="black"
        fillOpacity="0.25"
      />
    </svg>
  );
}
